import { Check, Phone } from "lucide-react";
import { priceList, brand, formatPrice } from "../mock";
import { Button } from "./ui/button";

export default function PriceList() {
  return (
    <section id="listino" className="py-20 bg-[#f5f6f8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-2xl mb-12">
          <span className="text-[#e2001a] font-semibold text-sm uppercase tracking-wide">Listino e offerte</span>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-[#16181d] mt-2">
            Prezzi chiari, nessuna sorpresa
          </h2>
          <p className="text-gray-500 mt-3">
            Alcuni dei nostri servizi e pneumatici più richiesti. Contattaci per un preventivo
            personalizzato sul tuo veicolo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {priceList.map((p) => (
            <div
              key={p.name}
              className={`flex items-center justify-between gap-4 rounded-2xl border p-5 transition-colors ${
                p.highlight
                  ? "bg-[#e2001a] border-[#e2001a] text-white"
                  : "bg-white border-gray-100 hover:border-[#e2001a]/40"
              }`}
            >
              <div className="flex items-start gap-3">
                <span className={`inline-flex items-center justify-center w-9 h-9 rounded-lg shrink-0 ${p.highlight ? "bg-white/20" : "bg-[#f5f6f8]"}`}>
                  <Check className={`w-4 h-4 ${p.highlight ? "text-white" : "text-[#e2001a]"}`} />
                </span>
                <div>
                  <div className="flex items-center gap-2">
                    <p className={`font-semibold ${p.highlight ? "text-white" : "text-[#16181d]"}`}>{p.name}</p>
                    <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded-full ${p.highlight ? "bg-white/20 text-white" : "bg-[#f5f6f8] text-gray-500"}`}>{p.tag}</span>
                  </div>
                  <p className={`text-sm mt-0.5 ${p.highlight ? "text-white/80" : "text-gray-500"}`}>{p.note}</p>
                </div>
              </div>
              <p className={`font-display font-extrabold text-xl whitespace-nowrap ${p.highlight ? "text-white" : "text-[#16181d]"}`}>
                {formatPrice(p.price)}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 bg-white rounded-2xl border border-gray-100 p-6">
          <p className="text-gray-600 text-sm">
            I prezzi indicati sono indicativi e possono variare in base al modello del veicolo.
          </p>
          <a href={brand.phoneHref}>
            <Button className="rounded-full bg-[#e2001a] hover:bg-[#c00016] whitespace-nowrap">
              <Phone className="w-4 h-4 mr-2" /> Chiedi un preventivo
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
